import { render, staticRenderFns } from "./TrinketList.vue?vue&type=template&id=325ed191"
import script from "./TrinketList.vue?vue&type=script&lang=js"
export * from "./TrinketList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports